import { bem } from '@socialive/common';
import PropTypes from 'prop-types';
import CloseIcon from '../../Icons/CloseIcon';
import './toast.css';
import ToastIcon from './ToastIcon';

/*
#tailwind
toast toast toast--clickable toast--chat toast--info toast--danger toast--warning toast--success 
*/

function Toast({
  title,
  message,
  bottom,
  top,
  right,
  left,
  onClick,
  onClose,
  context,
  className,
  notificationConfig,
  icon,
  ...other
}) {
  return (
    <div
      onClick={onClick}
      {...notificationConfig?.ariaProps}
      className={bem`toast--${{ [context]: true, clickable: onClick }}  ${
        notificationConfig?.visible ? 'animate-enter' : 'animate-leave'
      } ${className}`}
      style={{ marginTop: top, marginRight: right, marginLeft: left, marginBottom: bottom }}
    >
      <div className="toast__innerBox">
        <div className="toast__iconContainer">
          <ToastIcon icon={icon ?? context} />
        </div>
        <div className="toast__contentContainer">
          <div className="toast__title">{title}</div>
          {message ? <div className="toast__body">{message}</div> : null}
        </div>
        <button type="button" onClick={onClose} className="toast__closeButton">
          <CloseIcon />
        </button>
      </div>
    </div>
  );
}

Toast.propTypes = {
  title: PropTypes.node,
  message: PropTypes.node,
  context: PropTypes.oneOf(['chat', 'info', 'danger', 'success', 'warning']),
  className: PropTypes.string,
  onClick: PropTypes.func,
  onClose: PropTypes.func.isRequired,
  notificationConfig: PropTypes.shape({
    ariaProps: PropTypes.shape({ role: PropTypes.string, 'aria-live': PropTypes.string }),
    createdAt: PropTypes.number,
    duration: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    message: PropTypes.func,
    pauseDuration: PropTypes.number,
    // eslint-disable-next-line react/forbid-prop-types
    style: PropTypes.object,
    type: PropTypes.string,
    visible: PropTypes.bool,
  }),
  top: PropTypes.string,
  right: PropTypes.string,
  bottom: PropTypes.string,
  left: PropTypes.string,
  icon: PropTypes.node,
};

Toast.defaultProps = {
  className: undefined,
  context: 'info',
  top: '4px',
  right: '4px',
  bottom: '4px',
  left: '4px',
  icon: undefined,
  message: undefined,
  notificationConfig: undefined,
  onClick: undefined,
  title: undefined,
};

export default Toast;
